export default __webpack_public_path__ + "static/media/Solana Full.39d7af27.png";